// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Segment } from 'semantic-ui-react'
import bgimg from '../assets/ctabg.png'

export default class PoweredBy extends Component {
  render () {
    return (
      <div
        className='centerX mt'
        style={{
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundImage: 'url(' + bgimg + ')',
          backgroundColor: '#fcfcfc'
        }}>
        <Segment
          textAlign='center'
          padded='very'
          style={{ color: '#000', marginBottom: '10vh', marginTop: '10vh', borderRadius: 7}}>
          {/* <h5>This content is neither created nor endorsed by Murkstom.</h5> */}
          <a style={{ color: '#999' }} href='/terms'>
            Terms of service{' '}
          </a>
          -
          <a style={{ color: '#999' }} href='/privacy'>
            {' '}
            Privacy Policy
          </a>
          <h3>
            Powered by{' '}
            <a style={{ color: '#74A4DC' }} href='/'>
              <b>Murkstom</b>
            </a>
          </h3>
        </Segment>
      </div>
    )
  }
}
